export const getPersonId = (person) =>
  `${person?.user_id ?? person?.userId ?? person?.user?.id ?? person?.id ?? ''}`;

export const getPersonName = (person) => {
  const value = `${person?.name ?? person?.fullName ?? person?.username ?? ''}`.trim();
  if (value) return value;
  const id = getPersonId(person);
  return id ? `User ${id}` : 'Unknown user';
};

export const getInitials = (value = '') => {
  const words = `${value}`.trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return `${words[0][0] || ''}${words[1][0] || ''}`.toUpperCase();
};

export const formatClock = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '';
  return new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  }).format(date);
};

export const toNumberIfFinite = (value) => {
  const next = Number(value);
  return Number.isFinite(next) ? next : null;
};
